const Field = require("components/forms/Field");

function Input({label, error, errorMessage, className, inputRef, children, required, tooltip, description, format, ...props}) {
	return (
		<Field label={label} error={error} errorMessage={errorMessage} className={className} required={required}
					 tooltip={tooltip} description={description} format={format}>
			<input ref={inputRef} {...props} />
			{children}
		</Field>
	);
}

module.exports = Input;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Input.js